import { EnrollmentEffortTier } from '@zorro/clients';
import { BadgeProps } from '@zorro/design-system/v2/Badge';
import { planTooltipLabels } from '@zorro/types';
import { useRoles } from '@zorro/web/ui-utils';

import { PlanBadge } from '../PlanBadge';

export const ENROLLMENT_EFFORT_TIER_LABELS = {
  [EnrollmentEffortTier.EASY_ENROLL]: 'Easy enroll',
  [EnrollmentEffortTier.EXTRA_STEPS]: 'Extra steps',
  [EnrollmentEffortTier.SELF_ENROLL]: 'Self-enroll',
} as const satisfies Partial<Record<EnrollmentEffortTier, string>>;

type EnrollmentEffortBadgeConfig = {
  label: string;
  color: BadgeProps['color'];
  tooltipLabel: string;
  adminTooltipLabel: string;
};

const BADGE_BY_TIER: Partial<
  Record<EnrollmentEffortTier, EnrollmentEffortBadgeConfig>
> = {
  [EnrollmentEffortTier.EASY_ENROLL]: {
    label: ENROLLMENT_EFFORT_TIER_LABELS[EnrollmentEffortTier.EASY_ENROLL],
    color: 'green',
    tooltipLabel: planTooltipLabels.easyEnroll,
    adminTooltipLabel: planTooltipLabels.easyEnrollAdmin,
  },
  [EnrollmentEffortTier.EXTRA_STEPS]: {
    label: ENROLLMENT_EFFORT_TIER_LABELS[EnrollmentEffortTier.EXTRA_STEPS],
    color: 'yellow',
    tooltipLabel: planTooltipLabels.extraSteps,
    adminTooltipLabel: planTooltipLabels.extraStepsAdmin,
  },
  [EnrollmentEffortTier.SELF_ENROLL]: {
    label: ENROLLMENT_EFFORT_TIER_LABELS[EnrollmentEffortTier.SELF_ENROLL],
    color: 'red',
    tooltipLabel: planTooltipLabels.selfEnroll,
    adminTooltipLabel: planTooltipLabels.selfEnrollAdmin,
  },
};

type Props = {
  enrollmentEffortTier?: EnrollmentEffortTier | null;
};

export const EnrollmentEffortBadge = ({ enrollmentEffortTier }: Props) => {
  const { isEmployeeOnlyRole } = useRoles();
  const badge = enrollmentEffortTier && BADGE_BY_TIER[enrollmentEffortTier];
  if (!badge) {
    return null;
  }

  return (
    <PlanBadge
      label={badge.label}
      color={badge.color}
      tooltipLabel={
        isEmployeeOnlyRole ? badge.tooltipLabel : badge.adminTooltipLabel
      }
      size="sm"
    />
  );
};
